export { kaardirakendus };

let closeVideo;

const kaardirakendus = () => {
    if (MODULE_NAME === "kaardirakendus") {
        var closeTimeout;
        var height = $(".content").height();
        $(".content-wrapper").css({
            minHeight: height
        });
    
        $(".reasons-to-use").on("click", function () {
            $(".reasons-to-use").hide();
            $(".reasons-to-use-content").slideDown("fast");
    
            dataLayer.push({
                'event': 'GAEvent',
                'eventCategory': 'Maaportaal',
                'eventAction': 'threeReasons'
            });
            return false;
        });
        $(".reasons-to-use-content").on("mouseenter", function () {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
                closeTimeout = false;
            }
        });
        $(".reasons-to-use-content").on("mouseleave", function () {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
            }
            var $this = $(this);
            closeTimeout = setTimeout(function () {
                $this.slideUp("fast", function () {
                    $(".reasons-to-use").show();
                });
            }, 500);
        });
        $(".close", $(".reasons-to-use-content")).on("click", function () {
            $(".reasons-to-use-content").slideUp("fast", function () {
                $(".reasons-to-use").show();
            });
            return false;
        });
        $(".choose-map-option").on("click", function () {
            $(".packets-container").css({
                "opacity": .2,
                "pointer-events": "none"
            })
            $(".cta-login-chosen").html("Valitud: <strong> " + $(this).data("map-type") + "</strong>")
            $(".cta-login").show();
        });
        $(".close-cta-login").on("click", function () {
            $(".packets-container").css({
                "opacity": 1,
                "pointer-events": "auto"
            })
            $(".cta-login").hide();
        })
        $(".button-start-video").on("click", function () {
            // setTimeout is necessary, because closeVideo() activates too fast;
    
            $("#video")[0].src = $(this).data('video-url') + "&autoplay=1";
            setTimeout(function () {
                $("body").addClass('video-open');
                $('.video-wrapper').show();
            }, 300)
        });
    
        closeVideo = function() {
            $("body").removeClass('video-open');
            $('.video-wrapper').hide();
            $("#video")[0].src = "";
        }
    
        $('.video-wrapper-close').on('click', function () {
            closeVideo();
        });
        $("body").on('click', function () {
            if ($(this).hasClass("video-open")) {
                closeVideo();
            }
        });
        $("body").on("keydown", function (e) {
            console.log(typeof e.keyCode, e.keyCode);
    
            if ($(this).hasClass("video-open") && e.keyCode === 27) {
                closeVideo();
            }
        });
    
    }
}